<page-title title="Víncular Especialista"></page-title>
<p>Criar Novo Especialista.</p>

<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Perfil">

    <ng-template mat-tab-label>
      <span>
        Perfil
      </span>
    </ng-template>

    <ng-template matTabContent>
      <app-practitioner-registration-by-organization [mode]="mode" [practitioner]="practitioner"
        [practitioner_id]="practitioner_id" (onUpdatePractitioner)="setPractitioner($event)">
      </app-practitioner-registration-by-organization>
    </ng-template>

  </mat-tab>

  <mat-tab label="Especialidades" [disabled]="objectIsEmpty(practitioner)">
    <ng-template mat-tab-label>
      <span [matTooltip]="objectIsEmpty(practitioner) ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Especialidades
      </span>
    </ng-template>
    <ng-template matTabContent>
      <app-practitioner-practitionerrole-by-form [practitioner]="practitioner"
        [mode]="mode"></app-practitioner-practitionerrole-by-form>
    </ng-template>

  </mat-tab>

  <mat-tab label="Qualificações" [disabled]="objectIsEmpty(practitioner)">
    <ng-template mat-tab-label>
      <span [matTooltip]="objectIsEmpty(practitioner) ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Qualificações
      </span>
    </ng-template>
    <ng-template matTabContent>
      <app-practitioner-qualification-form-by-organization [practitioner]="practitioner" mode="UPDATE"
        (onUpdatePractitioner)="setPractitioner($event)">
      </app-practitioner-qualification-form-by-organization>
    </ng-template>
  </mat-tab>





</mat-tab-group>

<div class="row">
  <mat-dialog-actions align="end">
    <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>

  </mat-dialog-actions>
</div>